export default [
  12, // Metodologia de rateio financeiro
  21, // Unidade de negócio padrão
  339, // Utilizar configurador de produto
  397, // Tipo operação saída consumidos
  398, // Tipo operação entrada fabricados
  399, // Tipo operação entrada defeito
  392, // Centro armazenagem produção
  393, // Centro armazenagem fabricados
  394, // Centro armazenagem defeito
  395, // Centro armazenagem perdidos
  400, // Tipo operação entrada perdidos
  402, // Leitura por
  403, // Area de Processo
  404, // Confirmar quantidades
  426, // Ocorrência de entrada fabricados
  427, // Ocorrência de entrada defeito
  428, // Ocorrência de entrada perdidos
  448, // Exigir 100% de rateio contábil
  449, // Exigir 100% de rateio gerencial quando houver relacionamento
  535, // Suprimir registros sem saldo na pesquisa de Estoque
  596, // Separar por lotes na disponibilidade
  671, // Suprimir Registros Zerados na Pesquisa de Lotes
  772, // Permite alterar os parametros
  901, // TG
  1031, // Avisar/Bloquear quantidade insuficiente no Leitor
  1067, // Permitir rateio para lançamentos de previsão
  1196, // Bloqueio de registros dos Acompanhamentos
  1295, // Bloquear inclusão de lançamentos com Empresa em branco
  1545, // Impressão de etiqueta disponível
  1632, // Visão aleatória para Contas Contábeis
  1633, // Visão aleatória para Contas Gerenciais
  1672, // Permitir informar a atividade da OS como retrabalho
  2016, // Divisão dos colaboradores padrão
  2549, // Ativar controle de substituição de demandas na produção
  2563, // Permitir acesso ao Cronograma do Projeto
  2608, // Permitir acessar projetos como PMO
  2666, // Permitir alterar atividade de apontamentos de projetos
  2756, // Personalização de nome e imagem do usuário
  2938, // Permitir editar o tempo de apontamento de projeto concluído
  3096, // Exigir informar colaborador ao ler ordem de produção
  3119, // Ao clicar no ícone da leitura da OP no portal, abrir:
  3227, // PC - MP - Inicializar o campo quantidade fabricada zerado
  3270, // PJ - GE - Permitir alterar ‘Faturar Atividade’ - Apont. de Projeto
  3271, // PJ - GE - Exigir ‘Causa’ ao desmarcar ‘Faturar Atividade’ - Apont Proj
  3076, // Utiliza autenticação em 2 etapas
  3239, // Local onde considerar o recurso A2F
  3279, // PJ - GE - Exibir atividades concluídas no Portal Projetos
];
